import { useDynamicEntity } from './useDynamicEntity';
import { useAuth } from './index';

const ISLEM_TURU_LABEL = {
  HESAPLANAN_PRIM: 'Hesaplanan Prim',
  EK_PRIM: 'Ek Prim',
  ODEME: 'Ödeme',
};

const useBonusPayments = () => {
  const { user } = useAuth();

  const dynamicHook = useDynamicEntity({
    entityType: 'bonusPayments',
    gqlEntityKey: 'bonus_payments',
    queryName: 'GET_BONUS_PAYMENTS_QUERY',
    createMutation: 'CREATE_BONUS_PAYMENT_MUTATION',
    updateMutation: 'UPDATE_BONUS_PAYMENT_MUTATION',
    deleteMutation: 'DELETE_BONUS_PAYMENT_MUTATION',
    transformData: (row) => ({
      ...row,
      company_name: row.company?.name || `Company ${row.company_id}`,
      user_name: row.user
        ? `${row.user.first_name || ''} ${row.user.last_name || ''}`.trim()
        : `Kullanıcı #${row.user_id}`,
      islem_turu_label: ISLEM_TURU_LABEL[row.islem_turu] || row.islem_turu,
      period_label: `${row.yil}/Q${row.ceyrek}`,
      userId: row.user_id,
      companyId: row.company_id,
    }),
    transformFormData: (formData) => ({
      user_id: parseInt(formData.user_id),
      islem_turu: formData.islem_turu,
      tarih: formData.tarih,
      yil: parseInt(formData.yil),
      ceyrek: parseInt(formData.ceyrek),
      tutar: parseFloat(formData.tutar) || 0,
      aciklama: formData.aciklama || null,
    }),
    customWhereCondition: user?.role === 'ROOT' ? {} : { company_id: { _eq: user?.companyId } },
  });

  return {
    ...dynamicHook,
    isRootUser: user?.role === 'ROOT',
  };
};

export { useBonusPayments };
